import { Components, Theme } from '@mui/material/styles';

export const autocomplete = (theme: Theme): Components => {
  const additionalGrey = theme.palette.grey.additionalGrey;
  const primaryMain = theme.palette.primary.main;
  const errorMain = theme.palette.error.main;
  const grey100 = theme.palette.grey[100];
  const textSecondary = theme.palette.text.secondary;
  const primaryLight = theme.palette.primary[100];

  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: 0,
          },
          '.Mui-disabled:hover fieldset': {
            borderColor: grey100,
          },
        },

        inputRoot: {
          padding: '0 !important',
          [theme.breakpoints.down('sm')]: {
            height: 30,
          },

          '& .MuiAutocomplete-input': {
            padding: theme.spacing(1.5, 1.5, 1.5, 2),
            height: 48,
            boxSizing: 'border-box',
            fontSize: '14px',

            [theme.breakpoints.down('sm')]: {
              fontSize: '16px',
              position: 'absolute',
              top: 0,
              left: 0,
              transform: 'scale(0.5625)',
              transformOrigin: 'top left',
              width: '177.78%',
              height: '53.33px',
              padding: '14px 36px',
              '&::placeholder': {
                fontSize: 'inherit !important',
                opacity: '1 !important',
                color: theme.palette.grey.placeholderGrey,
              },
              '&::-webkit-input-placeholder': {
                fontSize: 'inherit !important',
                opacity: '1 !important',
                color: theme.palette.grey.placeholderGrey,
              },
            },
          },

          '& .MuiInputBase-sizeSmall .MuiAutocomplete-input': {
            padding: '8px 0 8px 18px',
            height: 30,
            fontSize: '13px',
          },
        },

        popupIndicator: {
          color: grey100,
          padding: 4,

          '&:hover': {
            backgroundColor: primaryLight,
            color: primaryMain,
          },
        },

        paper: {
          marginTop: 4,
          borderRadius: 4,
          border: `1px solid ${grey100}`,
          boxShadow: '0px 4px 12px rgba(1, 102, 179, 0.1)',
          backgroundColor: theme.palette.common.white,
        },

        listbox: {
          padding: 4,
          maxHeight: 250,
          fontFamily: theme.typography.fontFamily,
          fontSize: '14px',

          '&::-webkit-scrollbar': {
            width: 6,
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: theme.palette.background.paper,
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: grey100,
            borderRadius: 3,

            '&:hover': {
              backgroundColor: additionalGrey,
            },
          },

          [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
          },
        },

        option: {
          padding: '8px 12px',
          borderRadius: 4,
          fontFamily: theme.typography.fontFamily,
          fontSize: '14px',
          color: theme.palette.text.primary,

          '&:hover': {
            backgroundColor: primaryLight,
          },

          '&.Mui-focused': {
            backgroundColor: `${primaryMain}15`,
          },

          '&[aria-selected="true"]': {
            backgroundColor: `${primaryMain}25`,
            color: primaryMain,
            fontWeight: 500,

            '&.Mui-focused': {
              backgroundColor: `${primaryMain}35`,
            },

            '&:hover': {
              backgroundColor: `${primaryMain}40`,
            },
          },

          [theme.breakpoints.down('sm')]: {
            padding: '6px 10px',
            fontSize: '12px',
          },
        },

        noOptions: {
          padding: 12,
          fontSize: '14px',
          color: textSecondary,
          textAlign: 'center',
          fontFamily: theme.typography.fontFamily,
        },
        loading: {
          padding: 12,
          fontSize: '14px',
          color: textSecondary,
          textAlign: 'center',
          fontFamily: theme.typography.fontFamily,
        },

        tag: {
          margin: 2,
          maxWidth: 'calc(100% - 6px)',
          fontFamily: theme.typography.fontFamily,
          fontSize: '13px',
          backgroundColor: primaryLight,
          color: primaryMain,

          [theme.breakpoints.down('sm')]: {
            fontSize: '11px',
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: theme.typography.fontFamily,
          fontSize: '13px',
          backgroundColor: primaryLight,
          color: primaryMain,

          '&:hover': {
            backgroundColor: `${primaryMain}30`,
          },

          [theme.breakpoints.down('sm')]: {
            fontSize: '11px',
            height: 24,
          },
        },
        deleteIcon: {
          color: grey100,
          fontSize: 18,

          '&:hover': {
            color: errorMain,
          },

          [theme.breakpoints.down('sm')]: {
            fontSize: 16,
          },
        },
      },
    },
  };
};
